import { ReactComponent as CloseIcon } from 'assets/images/close_24.svg';
import { ReactComponent as TrashIcon } from 'assets/images/ic_btn_delete.svg';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '../form-fields/Checkbox';
import './BulkActionsToolbar.less';
import { useSelectionContext } from './SelectionContext';

interface Props<T> {
  className?: string;
  items: T[];
  disabled?: boolean;
  onDelete?: (selectedIds: Set<string | number>) => void;
}

export function BulkActionsToolbar<T>({
  className,
  items,
  disabled,
  onDelete,
}: Props<T>) {
  const { t } = useTranslation();

  const {
    selectedIds,
    toggleAll,
    isAllSelected,
    isIndeterminate,
    clearSelection,
    selectedCount,
  } = useSelectionContext<T>();

  const allSelected = isAllSelected(items);

  return (
    <div className={clsx('bulk-actions-toolbar', className)}>
      <div className="bulk-actions-toolbar__selection-all">
        <Checkbox
          id="select-all-checkbox"
          checked={allSelected}
          disabled={disabled}
          indeterminate={isIndeterminate(items)}
          onChange={() => toggleAll(items)}
        />
        <label
          htmlFor="select-all-checkbox"
          className="bulk-actions-toolbar__label"
        >
          {t('bulk_actions.all')}
        </label>
      </div>

      {selectedCount > 0 && (
        <div className="bulk-actions-toolbar__actions">
          <div className="bulk-actions-toolbar__count-info">
            <button
              onClick={clearSelection}
              className="bulk-actions-toolbar__clear-button"
              disabled={disabled}
              aria-label="Clear selection"
            >
              <CloseIcon />
            </button>
            <span> {t('bulk_actions.selected', { n: selectedCount })}</span>
          </div>

          {onDelete && (
            <button
              onClick={() => onDelete(selectedIds)}
              className="bulk-actions-toolbar__delete-button"
              disabled={disabled}
            >
              <TrashIcon />
              <span>{t('bulk_actions.delete')}</span>
            </button>
          )}
        </div>
      )}
    </div>
  );
}
